"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cingia-de-botti": {
    "04b20fbf": [{
      "hkey": "1a82469d",
      "slug": "cingia-de-botti",
      "name": "Cingia de' Botti",
      "primary": true,
      "skipSearch": false
    }],
    "caselle": [{
      "hkey": "1a82469d",
      "slug": "cingia-de-botti",
      "name": "Cingia de' Botti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;